import api from "./axios";
import { ApiResponse } from "@/types/apiResponse";
import { NewsItem } from "@/types/news";

export async function fetchNews(): Promise<NewsItem[]> {
  const res = await api.get<ApiResponse<NewsItem[]>>("/news");

  return res.data.data;
}
